// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Tenant
 */
export interface Tenant {}

/**
 * Check if a given object implements the Tenant interface.
 */
export function instanceOfTenant(value: object): value is Tenant {
  return true;
}

export function TenantFromJSON(json: any): Tenant {
  return TenantFromJSONTyped(json, false);
}

export function TenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tenant {
  return json;
}

export function TenantToJSON(json: any): Tenant {
  return TenantToJSONTyped(json, false);
}

export function TenantToJSONTyped(
  value?: Tenant | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
